import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { setPatientData, deletePatientUploadedFiles } from '../../../actions';
import FileUploadCard from '../../../components/FileManager/FileUploadCard';
import FileDocumentCard from '../../../components/FileManager/FileDocumentCard';
import { toast } from 'sonner';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../api/patientApi';
import { deleteFileApi } from '../../../api/fileApi';
import { useParams } from 'react-router-dom';
import CustomSelectField from '../../../common/CustomSelectField';
import { renderCheckboxes } from '../../../common/inputField';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

import {
  IconButton,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@mui/material';
import { Table } from 'react-bootstrap';
import DateComponent from '../../Registrationform/components/dateComponent';
import dayjs from 'dayjs';
import { CustomTextArea } from '../../../common/CustomTextArea';

const EvalutionOfMalePartner = () => {
  const dispatch = useDispatch();
  const patientData = useSelector((state) => state.clinicalReducer);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    dispatch(setPatientData(`evalutionOfMalePartner.${name}`, value));
  };
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loadingText, setLoadingText] = useState('');
  const { id: patientId } = useParams();

  const handleRecentIssuesChange = (e, index) => {
    const { name, checked } = e.target;
    const updatedCheckboxes =
      patientData.evalutionOfMalePartner.recentIssues.map((item, idx) =>
        idx === index ? { ...item, checked } : item,
      );

    if (name === 'otherValue') {
      dispatch(
        setPatientData(
          'evalutionOfMalePartner.recentIssuesOther',
          e.target.value,
        ),
      );
    } else {
      dispatch(
        setPatientData(
          `evalutionOfMalePartner.recentIssues`,
          updatedCheckboxes,
        ),
      );
    }
  };

  const handleHistoryChange = (e, index) => {
    const { name, checked } = e.target;
    const updatedCheckboxes =
      patientData.evalutionOfMalePartner.personalHistory.map((item, idx) =>
        idx === index ? { ...item, checked } : item,
      );

    if (name === 'otherValue') {
      dispatch(
        setPatientData(
          'evalutionOfMalePartner.personalHistoryOther',
          e.target.value,
        ),
      );
    } else {
      dispatch(
        setPatientData(
          `evalutionOfMalePartner.personalHistory`,
          updatedCheckboxes,
        ),
      );
    }
  };

  const handleSurgriesChange = (e, index) => {
    const { name, checked } = e.target;
    const updatedCheckboxes = patientData.evalutionOfMalePartner.surgeries.map(
      (item, idx) => (idx === index ? { ...item, checked } : item),
    );

    if (name === 'otherValue') {
      dispatch(
        setPatientData('evalutionOfMalePartner.surgeriesOther', e.target.value),
      );
    } else {
      dispatch(
        setPatientData(`evalutionOfMalePartner.surgeries`, updatedCheckboxes),
      );
    }
  };

  const handleMedicalHistoryChange = (e, index) => {
    const { name, checked } = e.target;
    const updatedCheckboxes =
      patientData.evalutionOfMalePartner.medicalHistory.map((item, idx) =>
        idx === index ? { ...item, checked } : item,
      );

    if (name === 'otherValue') {
      dispatch(
        setPatientData(
          'evalutionOfMalePartner.medicalHistoryOther',
          e.target.value,
        ),
      );
    } else {
      dispatch(
        setPatientData(
          `evalutionOfMalePartner.medicalHistory`,
          updatedCheckboxes,
        ),
      );
    }
  };

  return (
    <div className="theme-blush">
      <div className="container-fluid">
        <div className="card">
          <div className="header">
            <p className="lead">EVALUATION OF MALE PARTNER</p>
          </div>
          <div className="body">
            <div className="card_name_container">
              {renderCheckboxes(
                patientData.evalutionOfMalePartner.recentIssues,
                handleRecentIssuesChange,
                'Recent Issues',
                'recentIssues',
                patientData.evalutionOfMalePartner.recentIssuesOther,
                true,
              )}
            </div>
            <div className="card_name_container" style={{ marginTop: '20px' }}>
              {renderCheckboxes(
                patientData.evalutionOfMalePartner.medicalHistory,
                handleMedicalHistoryChange,
                'Medical History',
                'medicalHistory',
                patientData.evalutionOfMalePartner.medicalHistoryOther,
                true,
              )}
            </div>
            <div className="card_name_container" style={{ marginTop: '20px' }}>
              {renderCheckboxes(
                patientData.evalutionOfMalePartner.personalHistory,
                handleHistoryChange,
                'Personal History',
                'personalHistory',
                patientData.evalutionOfMalePartner.personalHistoryOther,
                true,
              )}
            </div>
            <div className="card_name_container" style={{ marginTop: '20px' }}>
              {renderCheckboxes(
                patientData.evalutionOfMalePartner.surgeries,
                handleSurgriesChange,
                'Surgeries',
                'surgeries',
                patientData.evalutionOfMalePartner.surgeriesOther,
                true,
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EvalutionOfMalePartner;
